const styles = {
  container: {
    height: '100vh',
    width: '100vw',
    position: 'relative',
    backgroundColor: 'brand.main'
  },
  japetoRootDiv: {
    height: '100%',
    width: '100%',
    backgroundColor: 'transparent',
    position: 'absolute',
    top: 0,
    left: 0
  }
};

export default styles;
